export default {"src":"/_next/static/media/my-favorites-details-gray-heart.1bd5cb75.svg","height":40,"width":90,"blurWidth":0,"blurHeight":0};